import React from 'react';
import MessageDetail from "../sturtural/MessageDetail";
import { Link } from "react-router-dom";
import { Button } from 'primereact/button';

const DocumentValidationCard = ({data, handleDialogValidation}) => {
    const iconstyle = {
        'width': "48px",
        'height': "48px",
        'borderRadius': "10px"
    };

    const buttonstyle = {
        'width': "48px",
        'height': "48px",
        'top': "-12.25px",
        'left': "-2.32812px"
    };

    const handleStatus = (status) => {

        let color;
        let icon;
        let textcolor;
        
        switch (status) {
            case 'Sin Documento':
                color = 'gray-100';
                textcolor = 'gray-600';
                icon = 'pi pi-question';
            break;
            
            case 'En Proceso':
                color = 'yellow-100';
                textcolor = 'yellow-600';
                icon = 'pi pi-play';
            break;
           
            case 'Aprobado':
                color = 'green-100';
                textcolor = 'green-600';
                icon = 'pi pi-check-circle';
            break;

            case 'Rechazado':
                color = 'orange-600';
                textcolor = 'orange-100';
                icon = 'pi pi-exclamation-triangle';
            break;
            
            case 'cancelado':
                color = 'gray-100';
                textcolor = 'gray-600';
                icon = 'pi pi-minus-circle';
            break;
            
            default:
                color = 'orange-100';
                textcolor = 'orange-600';
                icon = 'pi pi-bell';
            break;    
        }
       
        return (
                <div className="flex align-items-center">
                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-${color} mr-3`} style={iconstyle}><i className={`${icon} text-xl text-${textcolor}`}></i></span>
                    <span className="text-900 font-medium text-2xl">{status}</span>
                </div>
        );
    }

    return (
        <>
            {!data ? (
                <MessageDetail mensaje="No se encontraron documentos"/>
            ):(
                data.map((el, index) => 
                    <div className="col-12 lg:col-4 p-3" key={index}>
                        <div className="shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex">
                            <div className="p-4">
                                {handleStatus(el.status)}
                                <div className="text-900 my-3 text-xl font-medium">{el.documento}</div>
                                <p className="mt-0 mb-3 text-700 line-height-3">{el.descripcion}</p>
                                {el.observacion && <MessageDetail color="error" mensaje={el.observacion} />}
                            </div>
                            <div className="px-4 py-3 surface-100 text-right">
                                <Link to={`/validacion-documentos/${el.solicitudid}/${el.adjuntoid}`}>
                                    <Button label="Validar" className="p-button-rounded p-button-outlined mr-2 mb-2"></Button>
                                </Link>

                                {/* <button className="p-button p-component p-button-rounded p-button-success" onClick={() => handleDialogValidation(el.adjuntoid, el.url_relativa, el.documento)}>
                                    <span className="p-button-icon p-c p-button-icon-left pi pi-external-link"></span>
                                    <span className="p-button-label p-c">Validar</span><span className="p-ink"></span>
                                </button> */}
                            </div>
                        </div>
                    </div> 
                )   
            )}
        </>
    );  
}

export default DocumentValidationCard;